import { useMemo } from "react";
import LoyaltyOffer from "../../../utils/LoyaltyOfferClass/LoyaltyOffer";
import { LoyaltyItemOffer } from "../../../utils/LoyaltyOfferClass/LoyaltyItemOffer";
import {
  appliedCollageGraphics,
  previewCollageGraphics,
} from "../../../utils/loyalty/offerCollage";
import {
  buildSelectionGroups,
  isSupportedGuestBuiltOffer,
} from "../../../utils/loyalty/offerSelection";
import { LoyaltyOfferGraphic } from "../../../utils/loyaltyTypes";
import {
  selectRedeemedLineUnits,
  selectRedeemedLoyaltyOfferRaw,
} from "../../redux/selectors/loyaltyCartSelectors";
import { useMenuLookups } from "../useMenuLookups";
import { useAppSelector } from "../useReduxHooks";
import { useOfferEntityAvailability } from "./useOfferEntityAvailability";

/**
 * What a BOGO or bundle collage draws: the guest's own items once this offer
 * is the one in the cart, otherwise one ring per item the offer is made of.
 * Any other offer gets its service graphics untouched.
 */
export const useOfferCollageGraphics = (
  offer: LoyaltyOffer | undefined
): LoyaltyOfferGraphic[] => {
  const { subItemLookup } = useMenuLookups();
  const isAvailable = useOfferEntityAvailability();
  const entityImageLookup = useAppSelector(
    (state) => state.config.entityImageLookup
  );
  const redeemedOffer = useAppSelector(selectRedeemedLoyaltyOfferRaw);
  const redeemedUnits = useAppSelector(selectRedeemedLineUnits);

  return useMemo(() => {
    const graphics = offer?.uiConfig?.graphics ?? [];

    if (
      !(offer instanceof LoyaltyItemOffer) ||
      !isSupportedGuestBuiltOffer(offer)
    ) {
      return graphics;
    }

    if (redeemedOffer?.id === offer.id && redeemedUnits.length) {
      return appliedCollageGraphics(redeemedUnits, graphics);
    }

    return previewCollageGraphics(
      buildSelectionGroups(
        offer,
        (entityId) => subItemLookup[entityId],
        isAvailable
      ),
      graphics,
      (entityId) => Boolean(entityImageLookup[entityId]?.itemImage)
    );
  }, [
    entityImageLookup,
    isAvailable,
    offer,
    redeemedOffer?.id,
    redeemedUnits,
    subItemLookup,
  ]);
};
